import { KeyboardEvent, useEffect, useState } from 'react'

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious
} from '~/components/UI/shadcn/pagination'

// import { PreserveLink } from '~/hooks/PreserveLink'

interface NestedUIPaginationProps {
  className?: string
  index: number
  size: number
  total: number
  onPageChange: (newPage: number) => void
}

const NestedUIPagination = (Props: NestedUIPaginationProps) => {
  const { className, index, size, total, onPageChange } = Props
  const [totalPages] = useState(total || 0)
  const [pageSize] = useState(size || 10)
  const [pageIndex, setPageIndex] = useState(index - 1 || 0)

  const pageCount = Math.ceil(totalPages / pageSize)

  useEffect(() => {
    // Call onPageChange with the 1-based page number
    onPageChange(pageIndex + 1)
  }, [pageIndex, onPageChange])

  let pages: number[] = []

  if (pageCount > 1 && pageCount <= 2) pages = [2]
  if (pageCount > 2 && pageCount <= 3) pages = [2, 3]
  if (pageCount > 3 && pageCount <= 4) pages = [2, 3, 4]
  if (pageCount > 4) pages = [2, 3, 4]

  if (pageIndex > 2 && pageIndex < pageCount - 3)
    pages = [pageIndex, pageIndex + 1, pageIndex + 2]

  if (pageCount > 4 && pageCount - 4 < pageIndex)
    pages = [pageCount - 3, pageCount - 2, pageCount - 1]

  const handleNextPage = () => {
    if (pageIndex < pageCount) setPageIndex(pageIndex + 1)
  }
  const handleKeyNextPage = (e: KeyboardEvent<HTMLAnchorElement>) => {
    if (pageIndex < pageCount && e.key === 'Enter') setPageIndex(pageIndex + 1)
  }

  const handlePrevPage = () => {
    if (pageIndex > 0) setPageIndex(pageIndex - 1)
  }
  const handleKeyPrevPage = (e: KeyboardEvent<HTMLAnchorElement>) => {
    if (pageIndex > 0 && e.key === 'Enter') setPageIndex(pageIndex - 1)
  }

  return (
    <Pagination className={className}>
      {totalPages > 0 && (
        <PaginationContent className='list-none'>
          <PaginationItem className='pr-2xs flex'>
            <PaginationPrevious
              onClick={() => handlePrevPage()}
              onKeyDown={e => handleKeyPrevPage(e)}
              className={`unstyled-link hover:bg-grey-l h-m w-m sm:h-l sm:w-l shrink-0 cursor-pointer rounded-full ${pageIndex <= 0 ? 'pointer-events-none opacity-50' : ''}`}
              aria-disabled={pageIndex <= 0}
              tabIndex={pageIndex <= 0 ? -1 : 0}
            />
          </PaginationItem>

          <PaginationItem>
            <PaginationLink
              // to={undefined}
              // search={`page=1`}
              onClick={() => setPageIndex(0)}
              onKeyDown={e => e.key === 'Enter' && setPageIndex(0)}
              className={`unstyled-link ring-offset-background focus-visible:ring-ring hover:bg-grey-l h-m w-m sm:h-l sm:w-l text-base-sm sm:text-base-md lg:text-base-lg inline-flex cursor-pointer items-center justify-center rounded-none font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden ${pageIndex === 0 ? 'bg-blue-l-40 text-blue-d hover:bg-grey-l dark:bg-blue-d-60 pointer-events-none font-bold' : ''}`}
              tabIndex={0}
            >
              1
            </PaginationLink>
          </PaginationItem>

          {pageCount <= 4 &&
            pages.map(p => (
              <PaginationItem key={p}>
                <PaginationLink
                  // to={undefined}
                  // search={`page=${p}`}
                  onClick={() => setPageIndex(p - 1)}
                  onKeyDown={e => e.key === 'Enter' && setPageIndex(p - 1)}
                  className={`unstyled-link ring-offset-background focus-visible:ring-ring hover:bg-grey-l h-m w-m sm:h-l sm:w-l text-base-sm sm:text-base-md lg:text-base-lg inline-flex cursor-pointer items-center justify-center rounded-none font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden ${pageIndex + 1 === p ? 'bg-blue-l-40 text-blue-d hover:bg-grey-l dark:bg-blue-d-60 pointer-events-none font-bold' : ''}`}
                  tabIndex={0}
                >
                  {p}
                </PaginationLink>
              </PaginationItem>
            ))}

          {pageCount > 4 && pageIndex > 2 && (
            <PaginationItem>
              <PaginationEllipsis className='h-m w-m sm:h-l sm:w-l' />
            </PaginationItem>
          )}

          {pageCount > 4 &&
            pages.map(p => (
              <PaginationItem key={p}>
                <PaginationLink
                  // to={undefined}
                  // search={`page=${p}`}
                  onClick={() => setPageIndex(p - 1)}
                  onKeyDown={e => e.key === 'Enter' && setPageIndex(p - 1)}
                  className={`unstyled-link ring-offset-background focus-visible:ring-ring hover:bg-grey-l h-m w-m sm:h-l sm:w-l text-base-sm sm:text-base-md lg:text-base-lg inline-flex cursor-pointer items-center justify-center rounded-none font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden ${pageIndex + 1 === p ? 'bg-blue-l-40 text-blue-d hover:bg-grey-l dark:bg-blue-d-60 pointer-events-none font-bold' : ''}`}
                  tabIndex={0}
                >
                  {p}
                </PaginationLink>
              </PaginationItem>
            ))}

          {pageCount > 4 && pageIndex < pageCount - 2 && (
            <PaginationItem>
              <PaginationEllipsis className='h-m w-m sm:h-l sm:w-l' />
            </PaginationItem>
          )}

          {pageCount > 4 && (
            <PaginationItem>
              <PaginationLink
                // to={undefined}
                // search={`?page=${pageCount}`}
                onClick={() => setPageIndex(pageCount - 1)}
                onKeyDown={e =>
                  e.key === 'Enter' && setPageIndex(pageCount - 1)
                }
                className={`unstyled-link ring-offset-background focus-visible:ring-ring hover:bg-grey-l h-m w-m sm:h-l sm:w-l text-base-sm sm:text-base-md lg:text-base-lg inline-flex cursor-pointer items-center justify-center rounded-none font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden ${pageIndex + 1 === pageCount ? 'bg-blue-l-40 text-blue-d hover:bg-grey-l dark:bg-blue-d-60 pointer-events-none font-bold' : ''}`}
                tabIndex={0}
              >
                {pageCount}
              </PaginationLink>
            </PaginationItem>
          )}

          <PaginationItem className='pl-2xs flex'>
            <PaginationNext
              onClick={() => handleNextPage()}
              onKeyDown={e => handleKeyNextPage(e)}
              className={`unstyled-link hover:bg-grey-l h-m w-m sm:h-l sm:w-l shrink-0 cursor-pointer rounded-full ${pageIndex > pageCount - 2 ? 'pointer-events-none opacity-50' : ''}`}
              aria-disabled={pageIndex > pageCount - 2}
              tabIndex={pageIndex > pageCount - 2 ? -1 : 0}
            />
          </PaginationItem>
        </PaginationContent>
      )}
    </Pagination>
  )
}

export default NestedUIPagination
